import { SectionHeading } from '@/components/InvoiceReportDetailDrawer/parts/SectionHeading';
import type { ReportInferencesMismatchViewData } from '@/hooks/report_inferences/useReportInferencesMismatchCaptions';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { ApplicationDetail } from './ApplicationDetail';

type ApplicationContentProps = {
  reportId: string;
  paymentTotalAmount?: string | null;
  onMismatchViewDataChange?: Dispatch<
    SetStateAction<ReportInferencesMismatchViewData | undefined>
  >;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const ApplicationContent: FC<ApplicationContentProps> = memo(
  ({
    reportId,
    paymentTotalAmount,
    onMismatchViewDataChange,
    initialOpen,
    onToggle,
  }) => {
    const { t } = useTranslation();

    return (
      <SectionHeading
        initialOpen={initialOpen}
        title={t('application_content.section_title')}
        onToggle={onToggle}
      >
        <ApplicationDetail
          reportId={reportId}
          paymentTotalAmount={paymentTotalAmount}
          onMismatchViewDataChange={onMismatchViewDataChange}
        />
      </SectionHeading>
    );
  }
);
ApplicationContent.displayName = 'ApplicationContent';
